//import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const EmployeeKPIEntry = () => {

  const today = new Date().toISOString().split("T")[0];
  const [empIds, setEmpIds] = useState([]);
  const [errors, setErrors] = useState({});

  const [isEditable, setIsEditable] = useState(false);

  const [headerData, setHeaderData] = useState({
    emp_id: "",
    entry_date: today
  });

  const [kpiReviewRows, setKpiReviewRows] = useState([{
         kpi_id: "", 
         entry_irn: "",
         kpi_name : "", 
         freq: "", 
         freq_desc: "", 
         emp_rating: "", 
         emp_rem: "",
         not_appl: "",
         sup_rating: "",
         sup_rem: ""}]);

  const inputRefs = useRef([]);

  /// Load KPIs assigned to employee

  useEffect(() => {

    loadMyTeamMembers();
    
  }, []);

  const loadMyTeamMembers = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/ddl_Team_Members`);

      if (response.data && response.data.length > 0) {
        setEmpIds(response.data);
      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  };

  const handleReviewEmpKpi = async () => {

    try {

      if (!headerData.entry_date || headerData.entry_date === '') {
        setErrors({ entry_date: true });
        toast.error("Please enter Date.");
        return;
      }

      if (!headerData.emp_id || headerData.emp_id === '') {
        setErrors({ emp_id: true });
        toast.error("Please Select Employee for KPI Review and Update.");
        return;
      }

      const response = await axios.get(`${BASE_URL}/api/get_Emp_KPI_Sup_Review`,
             { params: { entry_date: headerData.entry_date, emp_id: headerData.emp_id } });

      if (response.data && response.data.length > 0) {
        setKpiReviewRows(response.data);
      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  }

  // const handleKeyNavigation = (e, rowIndex, colIndex) => {

  //   let newRow = rowIndex;
  //   let newCol = colIndex;

  //   if (newRow < 0 || newCol < 0) return;

  //   switch (e.key) {
  //     case "ArrowUp":
  //       newRow = rowIndex - 1;
  //       break;
  //     case "ArrowDown":
  //       newRow = rowIndex + 1;
  //       break;
  //     // case "ArrowLeft":
  //     //   newCol = colIndex - 1;
  //     //   break;
  //     // case "ArrowRight":
  //     //   newCol = colIndex + 1;
  //     //   break;
  //     case "Enter":
  //       newRow = rowIndex + 1;
  //       break;
  //     default:
  //       return;
  //   }

  //   e.preventDefault();

  //   if (
  //     inputRefs.current[newRow] &&
  //     inputRefs.current[newRow][newCol]
  //   ) {
  //     inputRefs.current[newRow][newCol].focus();
  //   }
  // };

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const handleKpiChange = async (index, e) => {

    setErrors({});

//    const { name, value } = e.target;
    const { name, value, type, checked } = e.target;
    const updatedRows = [...kpiReviewRows];

    let finalValue = value;

    // Checkbox values should be boolean 

    if (type === "checkbox") { 
      finalValue = checked ? "Y" : "N"; 
      if (name === "not_appl" && checked) { 
        updatedRows[index].sup_rating = 0; 
      }
    }

    if (name === "sup_rating") {
      finalValue = value === "" ? "" : Number(value);
    }

    updatedRows[index][name] = finalValue;

    setKpiReviewRows(updatedRows);

  };

  const handleNew = () => {

    setIsEditable(true);

    setTimeout(() => {
      inputRefs.current[0]?.[0]?.focus();
    }, 100);

  };

  const handleClear = () => {

    if (window.confirm("Clear data?")) {

      setIsEditable(false);

      setHeaderData({
        emp_id: "",
        entry_date: today
      });

      setKpiReviewRows([]);

    }

  };

  const handleSave = async () => {

    let rowErrors = {};
    let errorMessage = "";
    let errorRowIndex = null;

    for (let index = 0; index < kpiReviewRows.length; index++) {

      const row = kpiReviewRows[index];
      const rating = row.sup_rating;
      const not_appl = row.not_appl || 'N';

      let errors = {};

//      if (row.freq === "D") {

        if ((!rating || rating === '') && not_appl === 'N') {
          errors.sup_rating = true;
          errorMessage = `Supervisor Rating is mandatory at Row # ${index + 1}`;
        }
  
        if (errorMessage) {
          errorRowIndex = index;
          rowErrors[index] = errors;
          break;
        }
      }

  //  }

    // ✅ If error found
    if (errorRowIndex !== null) {
      setErrors({ rowErrors });
      toast.error(errorMessage);
      setTimeout(() => {
        inputRefs.current[errorRowIndex]?.[0]?.focus();
      }, 100);
      return;
    }

    if (!window.confirm("Sure you want to Update the inputs ?")) {
      return;
    }

    try {
      
      const response = await axios.post(`${BASE_URL}/api/upd_Sup_Review_Kpi`, {
        header: headerData,
        details: kpiReviewRows
      });

      if (response.data.message === '1') {
        toast.success("Employee KPI updated successfully");
        setHeaderData({
          emp_id: "",
          entry_date: today
        });
        setKpiReviewRows([]);
        setIsEditable(false);
      }

    } catch (err) {
      console.error(err);
      toast.error("Error updating Employee KPI");
    }

  };


  const options_emp = empIds.map(code => ({
    value: code.emp_id,
    label: code.emp_name
  }));

  return (

    <Container fluid className="p-3">

      {/* HEADER */}

      <Card className="mb-3 p-3">

        <Row className="mb-3">
          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Date
              </InputGroup.Text>

              <input
                type="date"
                className="form-control"
                name="entry_date"
                value={headerData.entry_date}
                max={today}
                disabled={!isEditable}
                onChange={handleHeaderChange}
              />
            </InputGroup>

          </Col>

          {/* <Col md={1}>
             <label>Team</label>
          </Col> */}
 
          <Col md={6}>
            <Select name="emp_id"
              options={options_emp}
              value={options_emp.find(option => String(option.value) === String(headerData.emp_id)) || null}
              onChange={(selectedOption) => 
                           setHeaderData((prev) => ({ ...prev, emp_id: selectedOption ? selectedOption.value : "" })) }
              disabled={!isEditable}
              placeholder=" -- Select Team Member -- "
            />
          </Col>

          <Col md={3}>
            <Button
              style={{ width: "200px" }}
              variant="warning"
              onClick={handleReviewEmpKpi}
              disabled={!isEditable}
            >
              Review & Update KPIs
            </Button>

          </Col>

        </Row>

        {/* Buttons */}

        <div className="d-flex justify-content-end gap-2 flex-wrap">

          <Button
            style={{ width: "130px" }}
            variant="primary"
            onClick={handleNew}
            disabled={isEditable}
          >
            New
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="secondary"
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="success"
            onClick={handleSave}
            disabled={!isEditable}
          >
            Save
          </Button>

        </div>

      </Card>

      {/* KPI TABLE */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>

              <tr>
                <th style={{ width: "4%", textAlign: "center" }}>#</th>
                <th style={{ width: "23%", textAlign: "left" }}>KPI Name</th>
                <th style={{ width: "7%", textAlign: "left" }}>Frequency</th>
                {/* <th style={{ width: "8%", textAlign: "right" }}>Emp Rating</th> */}
                <th style={{ width: "25%", textAlign: "left" }}>Employee Remarks</th>
                <th style={{ width: "6%", textAlign: "center" }}>Not Appl</th>
                <th style={{ width: "8%", textAlign: "right" }}>Supervisor <br/> Rating</th>
                <th style={{ width: "18%", textAlign: "left" }}>Supervisor Remarks</th>
              </tr>

            </thead>

            <tbody>

              {kpiReviewRows.map((row, index) => (

                <tr key={row.kpi_id}>

                  <td style={{ textAlign: "center" }}>
                    {index + 1}
                  </td>

                  <td style={{ textAlign: "left", whiteSpace: "normal", overflowWrap: "normal", wordBreak: "normal" }}> {row.kpi_name} </td>

                  <td style={{ textAlign: "left" }}> {row.freq_desc} </td>

                  <td style={{ textAlign: "left", whiteSpace: "normal", overflowWrap: "normal", wordBreak: "normal" }}> {row.emp_rem} </td>

                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      name="not_appl"
                      checked={row.not_appl === "Y"}
                      disabled={!isEditable}
                      onChange={(e) => handleKpiChange(index, e)}
                      style={{
                        transform: "scale(1.6)",
                        cursor: isEditable ? "pointer" : "default"
                      }}
                    />
                  </td>

                  <td style={{ textAlign: "right" }}>
                    <input type="number" min="0"
                      max="10"
                      step="1"
                      //className="form-control"
                      className={`form-control ${errors?.rowErrors?.[index]?.sup_rating ? "is-invalid" : ""}`}
                      name="sup_rating"
                      value={row.sup_rating}
                      //disabled={!isEditable}
                      disabled={!isEditable || row.not_appl === "Y"}
                      style={{ textAlign: "right" }}
                      onChange={(e) => {
                        const value = e.target.value;
                        // allow empty
                        if (value === "") {
                          handleKpiChange(index, e);
                          return;
                        }
                        const num = Number(value);
                        if (num >= 0 && num <= 10) {
                          handleKpiChange(index, e);
                        }
                      }}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][0] = el;
                      }}
                      // onKeyDown={(e) => handleKeyNavigation(e, index, 0)}
                    />
                  </td>

                  <td>

                    <textarea
                      className={`form-control ${errors?.rowErrors?.[index]?.emp_rem ? "is-invalid" : ""}`}
                      //className="form-control"
                      name="sup_rem"
                      value={row.sup_rem}
                      disabled={!isEditable}
                      rows={1}
                      onChange={(e) => handleKpiChange(index, e)}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][1] = el;
                      }}
                      // onKeyDown={(e) => handleKeyNavigation(e, index, 1)}
                    />

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </Card>

    </Container>

  );

};

export default EmployeeKPIEntry;
